/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiQuery } from '@app/core/http/api-query';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { Media } from '@app/shared/components/media-library/media.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MediaLibraryService {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery): Observable<PaginatedResponse> {
    return this.http.get('v1/media', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((media: any) => {
          return new Media().deserialize(media);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/media/' + id);
  }

  update(model: Media): Observable<Media> {
    return this.http.put('v1/media/' + model.id, model).pipe(
      map((response: HttpResponse) => {
        return new Media().deserialize(response.data);
      })
    );
  }

  massDestroy(ids: Array<number>): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        media: ids.map((id) => {
          return { id: id };
        }),
      },
    };

    return this.http.delete('v1/media/mass_destroy', options);
  }

  massDownload(ids: Array<number>): Observable<any> {
    let params = new HttpParams();
    ids.forEach((id: number, index: number) => {
      params = params.set('media[' + index + '][id]', id.toString());
    });
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/zip',
      }),
      params: params,
    };
    return this.http.get('v1/media/mass_download', { ...options, ...{ responseType: 'blob' } });
  }
}
